<template>
    <EmptyOwnPhenotypeDialog v-model="emptyOwnPhenotypeOpen"/>
    <div class="order-summary-component">
        <div class="order-summary-wrapper pb-6">
            <h3 class="text-left ml-6 mb-4 mt-6 header">{{$t('reservation.order_summary_header')}}</h3>
            
            <div class="d-flex justify-space-between px-6 mt-4 value">
                <v-divider></v-divider>
            </div>
            
            <div class="d-flex justify-space-between px-6 mt-4 value">
                <span>{{$t('reservation.order_value_label')}}</span>
                <span>{{$n(value, 'currency', 'pl')}}</span>
            </div>
            <div class="text-left px-6 mb-8 mt-1 subvalue">
                {{$t('reservation.product_quantity_label')}} {{cart_size}}
            </div>
            <div
                v-if="discountItems.length && discountItems.find(e => e?.material_type == 'mtSemen')"
                class="d-flex justify-space-between px-6 mt-4 value"
            >
                <span class="discount-label text-left">{{$t('reservation.discount_value_semen')}}</span>
                <span>- {{
                    $n(discountItems
                        .filter(e => e?.material_type == 'mtSemen')
                        .reduce((a,e) => a += e?.price, 0), 'currency', 'pl')
                }}</span>
            </div>
            <div
                v-if="discountItems.length && discountItems?.find(e => e.material_type == 'mtCell')"
                class="d-flex justify-space-between px-6 mt-4 value"
            >
                <span class="discount-label text-left">{{$t('reservation.discount_value_cell')}}</span>
                <span>- {{
                    $n(discountItems
                        .filter(e => e?.material_type == 'mtCell')
                        .reduce((a,e) => a += e?.price, 0), 'currency', 'pl')
                }}</span>
            </div>

            <div v-if="transport && transport.find(e => e.code == location)?.transport.length">
                <div class="d-flex flex-column px-6 mt-4 value">
                    <v-divider></v-divider>
                </div>
                <div v-for="(t, index) in transport.find(e => e.code == location).transport" :key="index">
                    <div class="d-flex justify-space-between px-6 mt-4 value">
                        <span class="discount-label text-left">
                            {{ $t("reservation.transport") }}
                        </span>
                        <span>{{ $n(parseInt(t.price), 'currency', 'pl') }}</span>
                    </div>
                    <div class="text-left px-6 mb-8 mt-1 subvalue">
                        {{ $t(t.location_code) }}<img :src="shevronIcon" height="8" class="mx-2"/>{{ $t(location) }}
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column px-6 mt-2 value">
                <v-divider></v-divider>
            </div>
            <div class="text-left d-flex justify-space-between px-6 mt-8 value">
                <span>{{$t('reservation.total_order_value_label')}}</span>
                <span>{{$n(fullPrice ? fullPrice : this.value, 'currency', 'pl')}}</span>
            </div>
            <div class="text-left d-flex justify-space-between px-6 mt-1 whole_value">
                <span>{{$t('reservation.paid_order_value_label')}}</span>
                <span>{{$n(paidPrice, 'currency', 'pl')}}</span>
            </div>

            <div class="controls d-flex flex-column px-6">
                <v-btn
                    v-if="!discountItems?.length"
                    flat
                    rounded
                    color="primary"
                    height="48"
                    class="text-uppercase mt-6"
                    :disabled="cart_size < 1 || loading"
                    @click="bookMaterial()"
                >
                    {{$t('reservation.confirm_pre_reservation_btn')}}
                </v-btn>
                <v-btn
                    flat
                    rounded
                    color="primary"
                    height="48"
                    class="text-uppercase mt-4 mb-6"
                    :disabled="cart_size < 1 || loading"
                    @click="bookMaterial(paidPrice ? true : false)"
                >
                    {{ paidPrice ? $t('reservation.reserve_and_pay_btn') : $t('reservation.reserve_btn') }}
                </v-btn>
            </div>
            <div class="info-wrapper d-flex flex-row align-start px-6">
                <v-icon color="primary" size="22px" class="mr-3">mdi-information-outline</v-icon>
                <div class="text-left info">
                    {{$t('reservation.order_summary_info')}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from "vuex";
import { computed } from 'vue';
import EmptyOwnPhenotypeDialog from "./EmptyOwnPhenotypeDialogComponent";

export default {
    name: 'order-summary-component',
    props: {
        cart_size: {
            type: Number,
            default: 0,
        },
        value: {
            type: Number,
            default: 0
        },
        discountItems: {
            default: []
        },
        bookingCallback: {
            type: Function,
            default: () => {}
        },
        transport: {
            default: []
        },
        location: {
            type: String,
            default: ""
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    components: {
        EmptyOwnPhenotypeDialog,
    },
    data: () => {
        return {
            emptyOwnPhenotypeOpen: false,
        }
    },
    setup() {
        const store = useStore()
        const shevronIcon = computed({
            get: () => { return require('../assets/icons/chevron-right.svg'); }
        })
        return {
            shevronIcon,
            payment: computed(() => store.getters["reservationModule/getPayment"]),
            hasPhenotypeMode: (mode) => store.getters["phenotypeModule/hasPhenotypeMode"](mode)
        }
    },
    computed: {
        fullPrice() {
            let transportPrice = 0;
            
            if(this.transport.length) {
                transportPrice = this.transport
                    .find(e => e.code == this.location)?.transport
                    .reduce((a,e) => a += parseInt(e.price), 0) | 0; // <-- ???
            }
            return this.value + transportPrice;
        },
        paidPrice() {
            const discountPrice = this.discountItems?.reduce((a,e) => a += parseInt(e.price), 0);
            let transportPrice = 0;
            
            if(this.transport.length) {
                transportPrice = this.transport
                    .find(e => e.code == this.location)?.transport
                    .reduce((a,e) => a += parseInt(e.price), 0) | 0; // <-- ???
            }
            return this.value - discountPrice + transportPrice;
        }
    },
    methods: {
        getNoun(gender, count) {
            let noun = '';
            if(gender == 'female') {
                switch(count){
                    case 1:   noun = "dawczyni"; break;
                    case 2:
                    case 3:
                    case 4:   noun = "dawczynie"; break;
                    default : noun = "dawczyni"; break;
                }
            } else {
                switch(count){
                    case 1:   noun = "dawca"; break;
                    default:   noun = "dawców"; break;
                }
            }
            return ' ' + noun;
        },
        bookMaterial(payment = false) {
			this.$store.dispatch('breadcrumbModule/setRoute', [])
            if (!this.hasPhenotypeMode('own')) {
                this.emptyOwnPhenotypeOpen = true;
                return false;
            }

            this.$store.dispatch('reservationModule/setPayment', payment)

            this.bookingCallback(payment);
        },
        completeOrder() {}
    }
}
</script>

<style lang="scss" scoped>
.order-summary-wrapper {
    border: 1px solid $nsb-color-3;
    box-sizing: border-box;
    background: white;
    width: 100%;

    .header {
        @include nsb-gentium-bold;
        font-size: 23px !important;
        line-height: 26px;
    }
    .whole_value {
        @include nsb-font-header-bold;
        letter-spacing: 0.4px;
        font-size: 14px;
        line-height: 21px;
        color: $ds-primary;
    }
    .value {
        @include nsb-font-container;
        letter-spacing: 0.4px;
        font-size: 14px;
        line-height: 21px;
        color: $ds-primary;
    }
    .subvalue {
        @include nsb-font-label;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.4px;
        color: $ds-primary-3;
    }
    .controls {
        @include nsb-font-container-medium;
        font-size: 14px;
        line-height: 21px;
    }
    .info-wrapper {
        .info {
            @include nsb-font-container;
            color: $ds-primary-3;
            font-size: 12px;
            line-height: 18px;
        }
    }
    .discount-label {
        max-width: 190px;
    }
}
.back {
    @include nsb-back-link;
    cursor: pointer;
}

@media (min-width: 960px) {
    .order-summary-wrapper {
        max-width: 384px;
    }
}
</style>